<a class="nav__item" [href]="href" [target]="target" [ngClass]="css">
  <ng-content></ng-content>
</a>
